<form *ngIf='formGroup'
      [formGroup]='formGroup' class='widget'>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    >
      <ng-content></ng-content>
    </pt-input-label>
    <div
      [ngClass]="{'is-invalid': formGroup.invalid}"
      class='form-control form-control-sm ng-select-multiple-control'
    >
      <ng-select
        [closeOnSelect]='false'
        [id]='inputId'
        [items]='options?.items'
        [multiple]='true'
        [notFoundText]='notFoundText'
        [placeholder]='placeholder'
        [readonly]='disabled'
        bindLabel='{{options?.bindLabel}}'
        bindValue='{{options?.bindValue}}'
        formControlName='value'
        appendTo="body"
      ></ng-select>
    </div>
    <small
      [innerHTML]='help'
      class='form-text text-muted' id='ptWFilteredSelectHelp_{{controlName}}'
    ></small>
  </div>
</form>
